export default __webpack_public_path__ + "static/media/overviewBannerMobile.f0afc8ec.png";